export default __webpack_public_path__ + "static/media/otherOrganization.bf16f5b6.svg";